export default __webpack_public_path__ + "static/media/Puzzle.97ab8710.svg";